import { render, staticRenderFns } from "./SendMessageHistoryTable.vue?vue&type=template&id=ceae8eac&scoped=true&lang=pug"
import script from "./SendMessageHistoryTable.vue?vue&type=script&lang=ts"
export * from "./SendMessageHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageHistoryTable.vue?vue&type=style&index=0&id=ceae8eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceae8eac",
  null
  
)

export default component.exports